<template>
  <el-popover
    placement="bottom-start"
    :width="272"
    trigger="click"
    v-model:visible="isPopoverVisible"
    :show-arrow="false"
  >
    <template #reference>
      <div class="trigger">
        <span class="text-sm font-bold leading-6 text-muted-foreground">{{
          selectedLabel
        }}</span>
        <div class="w-4 h-4 flex justify-center items-center">
          <svg-icon name="sli-down" class="w-4 h-4 text-muted-foreground" />
        </div>
      </div>
    </template>

    <ul class="content">
      <li
        v-for="option in options"
        :key="option"
        @click="selectOption(option)"
        :class="['popover-items', { selected: option === modelValue }]"
      >
        {{ option }}
        <svg-icon
          v-if="option === modelValue"
          name="sli-selected"
          class="w-6 h-6 text-muted-foreground"
        />
      </li>
    </ul>
  </el-popover>
</template>

<script>
export default {
  name: "DropdownWrapper",
  props: {
    options: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      isPopoverVisible: false,
    };
  },
  computed: {
    selectedLabel() {
      return this.modelValue || "Выберите опцию";
    },
  },
  methods: {
    selectOption(option) {
      this.$emit("update:modelValue", option);
      this.isPopoverVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.trigger {
  @apply inline-flex items-center gap-1 cursor-pointer select-none;
}
.content {
  @apply p-2 space-y-2 rounded-xl bg-card border border-border;
}
.popover-items {
  @apply flex justify-between items-center px-3 py-2 text-muted-foreground text-base font-medium;
  @apply rounded-lg  cursor-pointer   hover:bg-muted transition-colors;
}
.selected {
  @apply bg-blue-50 text-foreground;
}
</style>
